<template>
  <div v-if="recentSuggestion?.length" class="mb-3">
    <div class="flex justify-between items-center mb-3">
      <span class="font-niceone-medium">{{ $t('search.search_history') }}</span>
      <niceone-image class="cursor-pointer" :src="$publicPath('/images/cart-buttons/remove.svg')" width="16"
                     @click="clearRecentSearchHistory"/>
    </div>

    <div class="flex gap-2 flex-wrap">
      <div v-for="(recent, index) in recentSuggestion" :key="`search-item-${index}`"
           @click="getSeoUrl(recent, index)"
           class="overflow-hidden border border-primary py-1.25 px-2.5 text-xs rounded-full cursor-pointer">
        <span class="stored-keywords" v-html="recent?.term || recent?.title"/>
      </div>
    </div>
  </div>
</template>

<script setup>
import {TRACKERS} from "@/constants/events";
import {track} from "@/composables/useTrackEvent";
import {COOKIE_KEYS} from "@/constants/cookie";
import {SEARCH_TYPES} from "@/constants/index";

const emit = defineEmits(['closeSearch']);
const router = useRouter();
const localPath = useLocalePath()

const searchSuggestions = useCookie(COOKIE_KEYS.SEARCH_SUGGESTIONS, {secure: true})
const recentSuggestion = computed(() => {
  if (!searchSuggestions.value) return []

  try {
    return searchSuggestions.value?.sort((a, b) => (a?.search_query ?? '').localeCompare(b?.search_query ?? ''))
  } catch (_) {
    return []
  }
})

const clearRecentSearchHistory = () => {
  searchSuggestions.value = null
}

const getSeoUrl = (item, index = 0, source_name = '') => {

  track(TRACKERS.SEARCH, {item, index, source_name})
  emit('closeSearch')

  if (item.type === SEARCH_TYPES.SEARCH.type) {
    return router.push(localPath({
      path: '/search',
      query: {q: item?.search_query}
    }))
  }

  router.push(useNuxtApp().$routerUrl(item?.search_query))
}
</script>
<style>
.stored-keywords em,
.stored-keywords b {
  font-weight: 400;
}
</style>
